import React, { useState, useEffect } from "react";
import "./App.css";
import LandingPage from "./components/LandingPage/LandingPage";
import AboutUs from "./components/AboutUs/AboutUs";
import Services from "./components/Services/Services";
import Plans from "./components/Plans/Plans";
import Blog from "./components/Blog/Blog";
import Carousel from "./components/Carousel/Carousel";

import Getintouch from "./components/Footer/Getintouch";


function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3800);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div className="loadingPg"> 
        <div class="custom-loader"></div>
        <div className="LoadingHeading">
        <h1 >Loading...</h1>
        </div>
        </div>
      ) : (
        <div>
          <LandingPage />
          <AboutUs />
          <Services />
          <Plans />
          <Blog />
          <Carousel />
          <Getintouch />
        </div>
      )}
    </div>
  );
}

export default App;
